import { Component, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'message-attachment-option',
	templateUrl: 'message-attachment-option.html'
})
export class MessageAttachmentOptionComponent {

	@Output("onCameraClick") onCamera: EventEmitter<any> = new EventEmitter();
	@Output("onTemplateClick") onTemplate: EventEmitter<any> = new EventEmitter();
	@Output("onPersonClick") onPerson: EventEmitter<any> = new EventEmitter();

	constructor() {

	}

}



// WEBPACK FOOTER //
// ./src/components/message-attachment-option/message-attachment-option.ts